/* tslint:disable */
/* eslint-disable */
/**
 * OU-AAO API
 * This is a definition of Osaka University AAD Application API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: t.shinohara@mmj.ne.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  EducationCertificateCategoryType,
  EducationCertificateCategoryTypeFromJSON,
  EducationCertificateCategoryTypeFromJSONTyped,
  EducationCertificateCategoryTypeToJSON,
} from './'

/**
 *
 * @export
 * @interface EducationCertificateCategory
 */
export interface EducationCertificateCategory {
  /**
   *
   * @type {number}
   * @memberof EducationCertificateCategory
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof EducationCertificateCategory
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof EducationCertificateCategory
   */
  nameJa: string
  /**
   *
   * @type {Array<EducationCertificateCategoryType>}
   * @memberof EducationCertificateCategory
   */
  types: Array<EducationCertificateCategoryType>
}

export function EducationCertificateCategoryFromJSON(json: any): EducationCertificateCategory {
  return EducationCertificateCategoryFromJSONTyped(json, false)
}

export function EducationCertificateCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EducationCertificateCategory {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    nameJa: json['nameJa'],
    types: (json['types'] as Array<any>).map(EducationCertificateCategoryTypeFromJSON),
  }
}

export function EducationCertificateCategoryToJSON(
  value?: EducationCertificateCategory | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    nameJa: value.nameJa,
    types: (value.types as Array<any>).map(EducationCertificateCategoryTypeToJSON),
  }
}
